module.exports = __webpack_public_path__ + "img/hips.1a69385e.png";